import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import { Image } from 'bricks';
import { SharedZoneBlocks, SharedZonePromoBlocks } from 'store/SharedZone/blocks/selectors';

import styles from './styles.pcss';

const cx = classNames.bind(styles);

function PromoBlockImage({ src, url, title, className, imgSrc, isList, isCompact }) {
  return (
    <a
      href={url}
      className={cx((!!isList && !!isCompact && 'componentMob') || 'component', className)}
    >
      {imgSrc ?
        <Image fallbackClassName={cx('fallback')} src={imgSrc} alt={title} />
      : <Image fallbackClassName={cx('fallback')} src={src} alt={title} />}
    </a>
  );
}

PromoBlockImage.propTypes = {
  src: PropTypes.string,
  url: PropTypes.string,
  title: PropTypes.string,
  className: PropTypes.string,
  imgSrc: PropTypes.string,
  isList: PropTypes.bool,
  isCompact: PropTypes.bool,
};

const mapStateToProps = (state) => ({
  src: SharedZonePromoBlocks.getImageUrl(state),
  url: SharedZonePromoBlocks.getUrl(state),
  title: SharedZoneBlocks.getHeadline(state),
});

export default SharedZoneBlocks.connect(mapStateToProps)(PromoBlockImage);
